import { EarthOffIcon } from './EarthOffIcon';

/**
 * author: Austin Andrews
 * id 519E0041-FD5F-4DAD-96A4-BED1EDE9A20B
 * name earth-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-off.svg
 * tags
 * - Geographic Information System 
 * - Navigation 
 */
export const GlobeOffIcon = EarthOffIcon;
export default GlobeOffIcon